import { ADDRESS_TEXT_PATTERN, LOCALITY_PATTERN, POSTCODE_PATTERN } from "src/consts/address-validation";

interface AddressLookupValues {
    flatNumber: string;
    houseNumber: string;
    houseName: string;
    street: string;
    townCity: string;
    county: string;
    postcode: string;
}

/**
 * Determines whether an address returned by the postcode lookup can be used as-is, i.e. it
 * has every required field and contains only values our validation accepts. When it returns
 * false the manual address view should be shown so the user can see and correct the fields
 * inline, rather than being silently blocked on submit by hidden, unfixable fields.
 */
export const isAddressLookupResultComplete = (address: AddressLookupValues): boolean => {
    const hasBuildingIdentifier = !!address.flatNumber || !!address.houseNumber || !!address.houseName;
    const hasAllRequiredFields =
        hasBuildingIdentifier && !!address.street && !!address.townCity && !!address.county && !!address.postcode;

    const hasOnlyValidValues =
        ADDRESS_TEXT_PATTERN.test(address.flatNumber) &&
        ADDRESS_TEXT_PATTERN.test(address.houseNumber) &&
        ADDRESS_TEXT_PATTERN.test(address.houseName) &&
        ADDRESS_TEXT_PATTERN.test(address.street) &&
        LOCALITY_PATTERN.test(address.townCity) &&
        LOCALITY_PATTERN.test(address.county) &&
        POSTCODE_PATTERN.test(address.postcode);

    return hasAllRequiredFields && hasOnlyValidValues;
};

// Helper to remove ref from bound input props
export const withoutRef = <T extends { ref?: unknown }>(props: T): Omit<T, "ref"> => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { ref: _, ...rest } = props;
    return rest;
};
